module.exports = __webpack_public_path__ + "static/confused-deputy-360e8fe83f4d1eb7749886d7be922e39.svg";